<div class="mb-4 flex items-end gap-2">
  <app-model-field-select
    id="provider-select"
    label="project.steps.overallResults.selectProvider"
    [options]="options()"
    optionLabel="originalName"
    optionValue="hrToolDirectusId"
    [(value)]="selectedHrToolDirectusUuid!"
    [showClear]="false"
    [isReadOnly]="isDropdownReadOnly()"
    class="grow"
  />
  @if (canTagWinner()) {
    <p-button
      [label]="'project.steps.overallResults.tagWinner' | transloco"
      [loading]="isTaggingWinner()"
      [disabled]="isTaggingWinner()"
      (onClick)="tagWinner()"
      data-testid="tag-winner-button"
    ></p-button>
  }
</div>
